import React from 'react';
import { getAllPosts } from '../../utils/blogData';
import BlogCard from '../../components/BlogCard/BlogCard';
import styles from './Blog.module.css';

const Blog: React.FC = () => {
  const posts = getAllPosts();

  return (
    <div className={styles.blog}>
      <div className={styles.container}>
        <section className={styles.section}>
          <h1 className={styles.title}>Blog</h1>
          <p className={styles.subtitle}>Latest news and updates</p>
          <div className={styles.grid}>
            {posts.map(post => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blog;
